module.exports = __webpack_public_path__ + "static/level-2-card.bd9704c4.png";